import React, { useEffect, useState } from "react";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import data from "../../data/businessDevelopment.json";
import { BDSectionColumn } from "./BDSectionComponents";

export default function ScientifiCommunity() {
  pageTitle(data.title || "Scientifi Community");

  // Load dynamic section data
  const [sectionData, setSectionData] = useState(null);
  useEffect(() => {
    import("../../data/businessDevelopmentSection.json").then((mod) => {
      setSectionData(mod.columns);
    });
  }, []);

  return (
    <>
      <BannerSectionStyle3
        bgUrl={data.banner?.bgUrl}
        imgUrl={data.banner?.imgUrl}
        title={data.banner?.title || data.title}
      />
      {/* Dynamic Two-Column Section */}
      {sectionData && (
        <Section topMd={40} topLg={40} topXl={40}>
          <div className="bd-section-wrapper container">
            <div className="row">
              <BDSectionColumn column={sectionData[0]} className="bd-section-left" />
              <BDSectionColumn column={sectionData[1]} className="bd-section-right" />
            </div>
          </div>
        </Section>
      )}
    </>
  );
}
